import { HTTP } from '../../utils/http';
import { PaginationParams } from '../../../common/utils/pagination-params';

export const SMSTrackingService = {
    getSMSList(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`schools/${schoolId}/sms`);
        return HTTP.get(url);
    },

    getSMSById(schoolId, SMSId) {
        return HTTP.get(`/schools/${schoolId}/sms/${SMSId}`);
    },

    resendSMS(JSONform) {
        const form = JSON.parse(JSONform);
        return HTTP.post(`/schools/${form.schoolId}/sms/${form.id}`, form.message);
    },
};


// WEBPACK FOOTER //
// ./src/common/services/settings/sms-tracking.service.js